import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  column: {
    display: "flex",
    flexDirection: "column",
  },
});
